/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { FC } from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/DeleteAccountModal.module.css';
import Checkbox from '../../controlVariations/checkbox'; // 🔥 adjust path

type CheckboxState = boolean | 'indeterminate';

interface DeleteAccountModalProps {
	open: boolean;

	// Content
	title: string;
	description?: string;
	icon: string;

	// Buttons
	confirmText: string;
	cancelText: string;

	// Actions
	onConfirm: () => void;
	onCancel: () => void;

	// Checkbox control
	showCheckbox?: boolean;
	checkboxId?: string;
	checkboxLabel?: string;
	checkboxChecked?: CheckboxState;
	onCheckboxChange?: (checked: CheckboxState) => void;
	checkboxDisabled?: boolean;
	checkboxTriState?: boolean;

	// Disable confirm
	disableConfirm?: boolean;
}

const DeleteAccountModal: FC<DeleteAccountModalProps> = ({
	open,
	title,
	description,
	icon,
	confirmText,
	cancelText,
	onConfirm,
	onCancel,
	showCheckbox = false,
	checkboxId = 'delete-checkbox',
	checkboxLabel = '',
	checkboxChecked = false,
	onCheckboxChange,
	checkboxDisabled = false,
	checkboxTriState = false,
	disableConfirm = false,
}) => {
	if (!open) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{/* Icon */}
				<div className={styles.iconWrapper}>
					<span className={styles.icon}>
						<img src={icon} alt="" />
					</span>
				</div>

				{/* Title */}
				<h2 className={styles.title}>{title}</h2>

				{/* Optional Description */}
				{description && (
					<p className={styles.description}>{description}</p>
				)}

				{/* Optional Checkbox */}
				{showCheckbox && (
					<div className={styles.checkboxWrapper}>
						<Checkbox
							id={checkboxId}
							checked={checkboxChecked}
							onChange={value => onCheckboxChange?.(value)}
							label={checkboxLabel}
							disabled={checkboxDisabled}
							triState={checkboxTriState}
							size={18}
							checkedColor="#147b58" // ✅ GREEN
							indeterminateColor="#147b58" // ✅ GREEN
							borderColor="#D0D5DD"
							labelColor="#1E1E1E"
							labelFontSize={14}
						/>
					</div>
				)}

				{disableConfirm && (
					<p className={styles.offlineMessage}>
						You are offline. Deletion requires an internet
						connection.
					</p>
				)}

				{/* Actions */}
				<div className={styles.actions}>
					<button
						className={styles.deleteButton}
						onClick={onConfirm}
						disabled={disableConfirm}
					>
						{confirmText}
					</button>

					<button className={styles.keepButton} onClick={onCancel}>
						{cancelText}
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteAccountModal;
